import { render, staticRenderFns } from "./free-quickview.vue?vue&type=template&id=b00c7c0e&scoped=true&"
import script from "./free-quickview.vue?vue&type=script&lang=js&"
export * from "./free-quickview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b00c7c0e",
  null
  
)

export default component.exports